<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto d-flex flex-column justify-center align-center" v-if="cardList !== false && cardList.length == 0">
        <div class="text-center">
            <v-img src="@/assets/img/customer-level.svg" aspect-ratio="16/9" max-width="600" class="mx-auto"></v-img>
            <h4 class="text-primary my-5 font-weight-bold">مدیریت سطح مشتری</h4>
            <p class="text-grey-darken-1 text-meta my-4">با تعریف سطح برای مشتریان، علاوه بر امکان تعریف قوانین SLA متفاوت، می‌توانید سیاست‌گذاری‌های مختلف برای پاسخگویی به تیکت‌های مشتریان خود را نیز تعریف نمایید.</p>
            <v-btn @click="$router.push({path: '/settings/customerLevel/new' })" color="primary" class="mt-1" :disabled="!$system.license.features.customer_level"><v-icon class="me-1">add</v-icon>سطح جدید</v-btn>
        </div>
    </div>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto" v-else-if="cardList !== false">
        <v-col xl="4" lg="6" md="7" sm="9" cols="12">
            <p class="text-primary font-weight-bold mb-2">مدیریت سطح مشتری</p>
            <p class="text-meta text-grey-darken-1">با تعریف سطح برای مشتریان، علاوه بر امکان تعریف قوانین SLA متفاوت، می‌توانید سیاست‌گذاری‌های مختلف برای پاسخگویی به تیکت‌های مشتریان خود را نیز تعریف نمایید.</p>
            <v-btn color="primary" class="my-2" @click="$router.push({path: '/settings/customerLevel/new' })" :disabled="!$system.license.features.customer_level">
                <v-icon class="me-1">add</v-icon>سطح جدید
            </v-btn>
            <workingShiftCard
                icon="icon-level"
                :lists="cardList"
                @deleteCard="deleteList"
                @editCard="editList"
                :showDetails="false"
                :showActions='{editable:$auth.user.full_admin,deletable:$auth.user.full_admin && $system.license.features.customer_level}'
            ></workingShiftCard>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "سطح مشتری",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            cardList: false,
        };
    },
    methods: {
        deleteList(id) {
            if (this.$system.license.features.customer_level)
                this.$customerLevelDelete(id).then(async (res) => {
                    if (res && res.status == "DELETED") {
                        await this.getCustomerEvents();
                        this.$toast.success(res.message);
                        this.$system.setSystemDefaults(true);
                    }
                });
        },
        async getCustomerEvents() {
            await this.$customerLevelList().then((res) => {
                if (res && res.status == "OK") {
                    this.cardList = res.data;
                }
            });
        },
        editList(id) {
            this.$router.push({path: `/settings/customerLevel/${id}`});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.getCustomerEvents();
            this.$loading.finish();
        })
    },
};
</script>
